<template>
    <v-select v-model="graphic" :items="graphics" item-value="graphic_id" item-text="name" :label="label|translate" :clearable="clearable">
    </v-select>
</template>

<script>
  import {getGraphic} from "../helper";

  export default {
    name: 'GraphicSelector',
    props: {
      value: Number,
        label: {type: String, default: "Graphic"},
        clearable: {type: Boolean, default: true},
    },
    watch: {
      value () {
        if(this.graphic!==this.value){
          this.graphic = this.value
        }
      },
      graphic (newValue) {
        this.$emit('input', newValue)
      },
    },
    async beforeMount () {
        let df = await getGraphic({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name
        })
        this.graphics = df['result']
    },
      mounted(){
          if (this.value) {
              this.graphic = this.value
          }
      },
    data () {
      return {
        graphic: null,
        graphics:[]
      }
    },
  }
</script>

<style scoped>

</style>
